import { GAME_ID, REDUX_ACTIONS } from '../../data/constants';
import { SentenceZoneBorders, DoneButtonStates } from '../../data/enums';

const initialState = {
  usePracticeAssets: false,
  sentenceZoneBorder: SentenceZoneBorders.None,
  doneButtonState: DoneButtonStates.Invisible,
};

const framingReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case REDUX_ACTIONS.SET_SENTENCE_ZONE_BORDER:
      return {
        ...state,
        sentenceZoneBorder: action.border,
      };

    case REDUX_ACTIONS.SET_DONE_BUTTON_STATE:
      if (
        state.doneButtonState === DoneButtonStates.Correct &&
        action.doneButtonState !== DoneButtonStates.Invisible
      ) {
        return state;
      }
      return {
        ...state,
        doneButtonState: action.doneButtonState,
      };

    case REDUX_ACTIONS.SET_USING_PRACTICE_ASSETS:
      return {
        ...state,
        usePracticeAssets: action.payload,
      };

    default:
      return state;
  }
};

export default framingReducer;
